import { TranslocoService } from "@jsverse/transloco";
import { firstValueFrom } from "rxjs";

export function translocoPreloadLangFactory(transloco: TranslocoService): () => Promise<unknown> {
    return () => firstValueFrom(transloco.load("fr"));
}
